// Thư mục: src/services/hoSoXeService.js
import api from "@/api";

/**
 * API service cho Hồ sơ xe của tài xế
 */
export const HoSoXeApi = {
  /**
   * Lấy hồ sơ tổng hợp (Xe + Tài xế + Giấy tờ) cho tài xế đang đăng nhập.
   * Gọi API GET /api/ho-so-xe/cua-toi
   */
  getHoSoCuaToi() {
    return api.get("/api/ho-so-xe/cua-toi").then((res) => res.data);
  },
};
